import keyBinds from '../constants/keyBinds';

export default {
  created() {
    const escapeHandler = (e) => {
      if (e.key === keyBinds.escape) {
        this.escapeHandler();
      }
    };

    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
    });
  },
  methods: {
    escapeHandler() {
      throw new Error('Implement escape handler function');
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/escapable.js